import { getEnvVar } from "./envConfig";

const DEFAULT_IDLE_MINUTES = 120;

export const SESSION_LAST_ACTIVITY_KEY = "hmsSessionLastActivity";

export const getSessionIdleTimeoutMs = () => {
  const minutes = parseInt(
    getEnvVar("REACT_APP_SESSION_IDLE_MINUTES", String(DEFAULT_IDLE_MINUTES)),
    10
  );
  const safeMinutes =
    Number.isFinite(minutes) && minutes > 0 ? minutes : DEFAULT_IDLE_MINUTES;
  return safeMinutes * 60 * 1000;
};

export const touchSessionActivity = () => {
  localStorage.setItem(SESSION_LAST_ACTIVITY_KEY, Date.now().toString());
};

export const getSessionIdleMs = () => {
  const last = parseInt(localStorage.getItem(SESSION_LAST_ACTIVITY_KEY) || "0", 10);
  if (!last) return 0;
  return Date.now() - last;
};

export const clearSessionActivity = () => {
  localStorage.removeItem(SESSION_LAST_ACTIVITY_KEY);
};
